import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import '@containers/Login/Login.css';

import { Footer } from '@components/Footer/Footer';
import LoginForm from '@components/Forms/LoginForm/LoginForm';
import DefaultSpinner from '@components/Loader/Loader';
import LogoDark from '@components/Logo/Logo';

export const Login = () => {
  const { isLoading, isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/';
  useEffect(() => {
    if (isAuthenticated) navigate(from, { replace: true });
  }, [isAuthenticated, navigate, from]);
  if (isAuthenticated) {
    return (
      <>
        <div id="loginPage" className="login-body text-center">
          <div className="form-signin">
            <LogoDark href="/" className="login-logo" />
          </div>
        </div>
        <Footer />
      </>
    );
  }
  return (
    <>
      <div id="loginPage" className="login-body text-center">
        <div className="form-signin">
          {isLoading ? (
            <DefaultSpinner />
          ) : (
            <>
              <LogoDark href="/" className="login-logo" />
              <LoginForm />
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};
